// Texty rozhraní v češtině. Klíče určuje tento katalog, ostatní jazyky musí mít přesně tytéž
// (typová kontrola i test, NFR-005 AK 3). Zprávy jsou ve formátu ICU (FormatJS, DEC-001).
// Předložka „z/ze“ před číslem: ze 2, 3, 4, 7 (ze dvou, tří, čtyř, sedmi), jinak z.
export const cs = {
  "app.name": "mesketch",
  "lang.switch.label": "Jazyk",
  "lang.switch.other": "EN",
  "lang.switch.aria": "EN, přepnout do angličtiny",
  "nav.home": "Domů",
  "footer.by": "od SEL Institute",
  "footer.terms": "Obchodní podmínky",
  "footer.privacy": "Ochrana osobních údajů",
  "legal.title": "Připravujeme",
  "legal.body": "Text připravujeme s právníkem, brzy tady bude.",
  "notFound.title": "Tady nic není",
  "notFound.body": "Odkaz neplatí, nebo stránka neexistuje.",
  "error.generic": "Něco se pokazilo. Zkus to prosím znovu.",
  "error.offline": "Jsi offline. Odpovědi zůstávají v zařízení a odejdou po připojení.",
  "action.retry": "Zkusit znovu",

  "home.title": "Pochop, jak funguješ",
  "home.subtitle": "Jak prožíváš emoce, v čem je tvoje síla a jakou máš povahu. A co to znamená pro tvoje vztahy, práci i rozhodování. Zdarma a bez registrace.",
  "home.free.title": "{count, plural, =0 {Testy zdarma} =2 {Dva testy, zdarma} =3 {Tři testy, zdarma} =4 {Čtyři testy, zdarma} one {# test, zdarma} few {# testy, zdarma} other {# testů, zdarma}}",
  "home.side.what": "Co dostanu",
  "home.side.result": "Zobrazit výsledek",
  "home.example.sketch": "<b>Skica</b> · zdarma",
  "home.example.portrait": "<b>Portrét</b> · {style}",
  "home.example.portraitAlt": "Ukázka Portrétu technikou {style}: postava se září kolem hlavy a květem v hrudi.",
  "home.unsaved": "{count, plural, one {Máš tu # výsledek, který není uložený v Moje já.} few {Máš tu # výsledky, které nejsou uložené v Moje já.} other {Máš tu # výsledků, které nejsou uložené v Moje já.}}",
  "home.free.lead": "Každý zvlášť, v jakémkoli pořadí. Nejrychleji začneš emocemi.",
  "home.sample.labelMobile": "Takhle vypadá výsledek",
  "home.picture.eyebrow": "Ke každému výsledku",
  "home.deeper.title": "Když chceš jít hlouběji",
  "home.deeper.text": "Ke každému testu si můžeš odemknout podrobný výklad, rozvojový plán a obraz v dalších technikách, třeba k tisku.",
  "home.side.metaPaid": "Placený test, {duration}.",
  "home.side.metaFree": "Zdarma, {duration}.",
  "home.test.go": "Začít",
  "home.unsavedAction": "Uložit",
  "sketch.portrait.layer.adds.land": "Do obrazu přidá barevná pole a cestu z kamenů.",
  "sketch.portrait.layer.adds.sky": "Do obrazu přidá hvězdy a polární záři.",
  "sketch.portrait.layer.adds.inner": "Do obrazu přidá barvu nebe, záři a květ v hrudi.",
  "sketch.portrait.layer.adds.base": "Do obrazu přidá tvar za hlavou.",
  "sketch.portrait.layer.next": "Další krok:",
  "sketch.portrait.visitorTail": "K výsledku dostaneš vlastní skicu. {duration}, zdarma.",
  "sketch.portrait.visitorTailPaid": "K výsledku dostaneš vlastní skicu. {duration}.",
  "sketch.head.label": "{label} · výsledek a skica",
  "home.picture.text": "Tvary, barvy a rozmístění se počítají z tvých odpovědí. Každý test přidá jednu vrstvu. Můžeš ho sdílet a ostatní si z něj něco o tobě přečtou.",
  "home.picture.title": "Obraz, který nikdo jiný mít nebude",
  "home.where.decisions.text": "Kdy jedeš hlavou a kdy podle pocitu.",
  "home.where.decisions.title": "Rozhodování",
  "home.where.emotions.text": "Co dáváš najevo a co si necháváš pro sebe.",
  "home.where.emotions.title": "Emoce",
  "home.where.work.text": "Co tě nabíjí a kde se ti daří samo.",
  "home.where.work.title": "Práce",
  "home.where.relations.text": "Proč se v hádce stáhneš, nebo naopak přitlačíš.",
  "home.where.relations.title": "Vztahy",
  "home.where.lead": "Když víš, jak reaguješ a proč, líp rozumíš i tomu, co se děje mezi tebou a ostatními.",
  "home.where.title": "Kde se ti to hodí",
  "home.sample.bell": "Zvon: tečka vlevo od většiny lidí, na straně „uvnitř“.",
  "home.sample.text": "Smutek, zlost nebo zklamání obvykle zpracováváš uvnitř a navenek působíš klidně. Druzí tak někdy nepoznají, že tě něco trápí, dokud jim to neřekneš.",
  "home.sample.sentence": "Těžké pocity necháváš uvnitř víc než asi 7 z 10 lidí.",
  "home.sample.scale": "Vyjadřování nepříjemných pocitů",
  "home.sample.label": "Ukázka výsledku",
  "home.seoTitle": "testy osobnosti a emoční inteligence zdarma",
  "home.eyebrow": "Testy osobnosti a emoční inteligence",
  "home.trust.text": "Otázky pocházejí z IPIP, otevřené sady vědeckých dotazníků, se kterou pracují psychologové po celém světě. Výsledky ukazujeme poctivě, i s tím, jak přesné jsou. Za aplikací stojí SEL Institute, Institut sociálně-emočního vzdělávání.",
  "home.layer.rounds": "{rounds, plural, =3 {ve třech kolech} =4 {ve čtyřech kolech} =5 {v pěti kolech} other {v # kolech}}",
  "home.start.meta": "{duration} · zdarma",
  "home.start.fallback": "Začni: {name}",
  "save.first.title": "Kam ti máme Skicu uložit?",
  "save.first.lead": "Pošleme ti odkaz na přihlášení, bez hesla. V Moje já pak najdeš tuhle Skicu i další testy, i na jiném telefonu nebo počítači.",
  "save.first.skip": "Teď ne, ukaž mi Skicu",
  "home.empty": "Testy připravujeme.",
  "home.test.soon": "brzy",
  "home.test.done": "hotovo",
  "home.test.doneOpen": "hotovo · zobrazit výsledek",
  "home.test.inProgress": "rozpracováno",

  "intro.rounds": "{rounds, plural, one {# kolo} few {# kola} other {# kol}}",
  "intro.items": "{items, plural, one {# otázka} few {# otázky} other {# otázek}}",
  "intro.free": "Výsledek je zdarma a bez registrace.",
  "intro.sex": "Na pohlaví se neptáme, srovnáváme s obecnými normami.",
  "intro.basedOn": "Z čeho test vychází",
  "intro.start": "Začít",
  "intro.continue": "Pokračovat",
  "intro.restart": "Začít znovu",
  "intro.result": "Zobrazit výsledek",
  "intro.doneOn": "Test máš hotový {date}.",
  "intro.doneUndated": "Test máš hotový.",
  "intro.again": "Udělat test znovu",
  "intro.again.text": "Nový průchod trvá {duration}. Nový výsledek se stane platným a změní tvůj obraz, ten předchozí zůstane {signed, select, yes {v Moje já} other {v tomto zařízení}}.",
  "intro.again.yes": "Začít znovu",
  "intro.again.back": "Zpět k výsledku",
  "intro.paidSoon": "Tenhle test bude placený a připravujeme ho.",

  "test.round": "Kolo {round} {rounds, select, 2 {ze} 3 {ze} 4 {ze} 7 {ze} other {z}} {rounds}",
  "test.progress": "{index} {count, select, 2 {ze} 3 {ze} 4 {ze} 7 {ze} other {z}} {count}",
  "test.progressLabel": "Postup v kole",
  "test.back": "Zpět",
  "test.later": "Dát si pauzu",
  "test.answers": "Odpověď",
  "test.completing": "Skica se kreslí…",
  "test.offlineRound": "Výsledek kola se spočítá po připojení.",
  "test.sessionLost": "Toto sezení v zařízení není. Začni test znovu.",
  "test.pause.title": "Pauza",
  "test.pause.lead": "Pošleme ti odkaz, se kterým budeš pokračovat přesně odsud, i na jiném zařízení.",
  "test.pause.email": "E-mail",
  "test.pause.privacy": "E-mail použijeme jen k odeslání odkazu na pokračování. mesketch si ho neukládá, k odeslání ho předáme službě Ecomail.",
  "test.pause.privacyLink": "Ochrana osobních údajů",
  "test.pause.send": "Poslat odkaz",
  "test.pause.back": "Zpět do testu",
  "test.pause.noEmail": "Bez e-mailu",
  "test.pause.local": "Na tomto zařízení můžeš pokračovat kdykoli, odpovědi zůstanou uložené.",
  "test.pause.offline": "Bez připojení odkaz poslat nejde. Na tomto zařízení můžeš pokračovat kdykoli.",
  "test.pause.sent": "Odkaz je na cestě. Podívej se do e-mailu.",
  "test.pause.devLink": "Vývojový server e-maily neposílá. Odkaz na pokračování:",
  "test.pause.error": "E-mail se nepodařilo odeslat. Zkus to prosím za chvíli.",
  "test.pause.limit": "Odkaz už je na cestě. Další půjde poslat za chvíli.",
  "test.pause.invalid": "Zkontroluj prosím e-mailovou adresu.",
  "test.otherDevice": "Test pokračuje na jiném zařízení.",
  "result.lowReliability": "Tahle škála měří méně přesně než ostatní, ber výsledek spíš jako náznak.",
  "intro.sexAsked": "Na začátku se zeptáme, se kterou skupinou tě máme srovnávat, protože normy pro tento test jsou zvlášť pro ženy a pro muže.",
  "respondent.title": "S kým tě srovnáme?",
  "respondent.lead": "Normy pro tento test máme zvlášť pro ženy a pro muže. Abychom tvůj výsledek srovnali co nejlépe, vyber, se kterou skupinou tě máme srovnávat.",
  "respondent.f": "Se ženami",
  "respondent.m": "S muži",
  "respondent.note": "Na nic dalšího se neptáme. Volba slouží jen k výběru norem a později ji změnit nejde.",
  "intro.pause": "Test můžeš kdykoli přerušit tlačítkem „Dát si pauzu“ a pokračovat později, i na jiném zařízení.",
  "intro.pauseLocal": "Test můžeš kdykoli přerušit tlačítkem „Dát si pauzu“ a pokračovat později na tomto zařízení.",
  "claim.title": "Pokračování testu",
  "claim.lead": "Odkaz otevře rozpracovaný test na tomto zařízení. Na předchozím zařízení pak pokračovat nepůjde.",
  "claim.continue": "Pokračovat na tomto zařízení",
  "claim.gone": "Odkaz už neplatí",
  "claim.goneLead": "Odkaz jde použít jen jednou a po čase vyprší.",
  "claim.home": "Na úvodní stránku",
  "mail.login.subject": "Přihlášení do mesketch",
  "mail.login.greeting": "Ahoj,",
  "mail.login.lead": "tady je odkaz pro přihlášení do mesketch. Po otevření klikni na tlačítko Přihlásit se:",
  "mail.login.button": "Přihlásit se",
  "mail.login.validity": "Odkaz platí {minutes} minut a jde použít jednou.",
  "mail.login.ignore": "Když tenhle e-mail nečekáš, nic nedělej, odkaz sám vyprší.",
  "nav.me": "Moje já",
  "me.title": "Moje já",
  "me.lead": "Výsledky uvidíš i na dalších zařízeních. E-mail použijeme jen pro odkaz na přihlášení.",
  "me.email.label": "E-mail",
  "me.email.send": "Poslat odkaz",
  "me.email.sent": "Poslali jsme ti odkaz. Otevři ho a klikni na Přihlásit se.",
  "me.email.devLink": "Na vývojové verzi e-mail neodchází, tady je odkaz:",
  "me.email.failed": "E-mail se nepodařilo odeslat. Zkus to prosím za chvíli.",
  "me.rateLimited": "Moc pokusů za krátkou dobu. Zkus to prosím za chvíli.",
  "me.signedAs": "Přihlášeno jako {email}",
  "me.logout": "Odhlásit",
  "me.logoutAll": "Odhlásit na všech zařízeních",
  "me.tests": "Tvoje testy",
  "me.inProgress": "Rozpracováno · kolo {round} z {rounds}",
  "me.continue": "Pokračovat",
  "me.done": "Hotovo {date}",
  "me.open": "Otevřít",
  "me.history": "Starší výsledky",
  "me.newLink": "Nový odkaz pro sdílení",
  "me.newLinkNote": "Starý odkaz přestane platit.",
  "me.notStarted": "Ještě nezačato",
  "me.start": "Začít",
  "me.deviceTests": "Testy na tomto zařízení",
  "me.soon.title": "Připravujeme",
  "me.soon.portraits": "Koupené Portréty",
  "me.soon.pairs": "Páry",
  "me.soon.codes": "Zůstatky kódů",
  "me.soon.data": "Stažení a smazání dat",
  "me.soon.note": "připravujeme",
  "login.title": "Přihlášení",
  "login.lead": "Klikni na tlačítko a přihlásíš se na tomto zařízení na 90 dní.",
  "login.button": "Přihlásit se",
  "login.gone": "Odkaz už neplatí. Požádej o nový na stránce Moje já.",
  "login.goMe": "Na Moje já",
  "mail.resume.subject": "Odkaz na pokračování testu",
  "mail.resume.greeting": "Ahoj,",
  "mail.resume.lead": "tady je odkaz, se kterým budeš v testu na mesketch pokračovat od místa, kde je teď pauza:",
  "mail.resume.button": "Pokračovat v testu",
  "mail.resume.validity": "Odkaz platí {days} dní a jde použít jednou.",
  "mail.resume.ignore": "Když tenhle e-mail nečekáš, nic nedělej, odkaz sám vyprší.",

  "preview.banner": "Náhled",
  "preview.note": "Texty návrhu jsou podbarvené, chybějící text ukazuje svůj klíč.",

  "round.done": "Kolo {round} {rounds, select, 2 {ze} 3 {ze} 4 {ze} 7 {ze} other {z}} {rounds} hotové",
  "round.stage.ghost": "Obrys",
  "round.stage.noun": "Hlavní tah",
  "round.stage.adjective": "Nálada",
  "round.hint.race": "Tvůj typ se skládá ze dvou slov.",
  "round.hint.noun": "Hlavní tah je na papíře, slovo před ním ještě chybí.",
  "round.hint.both": "Tužkou se to ještě může změnit, inkoust drží.",
  "round.race.noun": "Kdo z nich jsi? Závod po kole {round}",
  "round.race.adjective": "Závod o přídavné jméno",
  "round.certainty": "Jak jistě to zatím víme",
  "round.word.drawing": "zatím se kreslí",
  "round.continue": "Pokračovat na kolo {round} · {items, plural, one {# otázka} few {# otázky} other {# otázek}}",
  "round.offline": "Náhled bez připojení. Až se připojíš, nahradí ho výsledek ze serveru.",
  "round.domains": "{count, plural, =6 {Šest dimenzí} =7 {Sedm dimenzí} =8 {Osm dimenzí} few {# dimenze} other {# dimenzí}}",

  "state.clear": "jasné",
  "state.almost": "skoro jasné",
  "state.drawing": "kreslí se",
  "bar.label": "{scale}: od pólu {low} k pólu {high}, {state}",
  "bar.labelFinal": "{scale}: od pólu {low} k pólu {high}",

  "sketch.title": "Skica je hotová",
  "sketch.titleVisitor": "Skica",
  "sketch.lead": "Typ a dimenze jsou tvoje zdarma.",
  "sketch.leadNoType": "Výsledek ve všech dimenzích je tvůj zdarma.",
  "sketch.type": "Tvůj typ",
  "sketch.typeVisitor": "Typ",
  "sketch.secondary": "Druhý nejbližší: {name} ({share}).",
  "sketch.certainty": "Jistota typu {share}.",
  "sketch.domains": "{count, plural, =6 {Šest dimenzí} =7 {Sedm dimenzí} =8 {Osm dimenzí} few {# dimenze} other {# dimenzí}}",
  "sketch.signature": "Rys, který tě odlišuje",
  "sketch.freeChapter": "Kapitola zdarma",
  "sketch.locked": "V Portrétu dál",
  "sketch.retry": "Projít test znovu",
  "sketch.again": "Udělat test znovu",
  "sketch.fits.question": "Sedí to na mě?",
  "sketch.fits.fits": "sedí",
  "sketch.fits.partly": "napůl",
  "sketch.fits.doesnt_fit": "nesedí",
  "sketch.share.title": "Odkaz na Skicu",
  "sketch.share.note": "Kdo má odkaz, Skicu uvidí. Odkaz můžeš kdykoli zrušit.",
  "sketch.share.copy": "Zkopírovat odkaz",
  "sketch.share.copied": "Zkopírováno",
  "sketch.share.revoke": "Zrušit odkaz a vytvořit nový",
  "sketch.share.revoked": "Starý odkaz už nefunguje.",
  "sketch.visitor.lead": "Tohle je něčí výsledek.",
  "sketch.visitor.cta": "Udělej si test",
  "sketch.visitor.own": "Udělej si svůj",
  "sketch.head": "Skica · {count, plural, one {# škála} few {# škály} other {# škál}}",
  "sketch.save.title": "Ulož si výsledek do Moje já",
  "sketch.save.lead": "Pošleme ti odkaz na přihlášení. Pak v Moje já najdeš tenhle i ostatní výsledky z tohoto zařízení, i na jiném telefonu nebo počítači.",
  "sketch.summary.balanced": "Nic z tebe výrazně nevyčnívá. Přikláníš se podle situace a podle lidí kolem.",
  "sketch.summary.topTitle": "Tvoje nejsilnější",
  "sketch.summary.topWorkTitle": "Nejvíc by tě bavilo",
  "sketch.summary.tie": "O místo se dělí:",
  "sketch.summary.top": "Tvoje nejsilnější: {list}.",
  "sketch.summary.topWork": "Nejvíc by tě bavilo: {list}.",
  "sketch.summary.topMore": "Tvoje nejsilnější: {list} a {count, plural, one {# další} few {# další} other {dalších #}} na společném {place}. místě.",
  "sketch.summary.topTie": "Tvoje nejsilnější: {count} na společném prvním místě.",
  "sketch.summary.topWorkMore": "Nejvíc by tě bavilo: {list} a {count, plural, one {# další} few {# další} other {dalších #}} na společném {place}. místě.",
  "sketch.summary.topWorkTie": "Nejvíc by tě bavilo {count, plural, one {# oblast} few {# oblasti} other {# oblastí}} stejně.",
  "sketch.insight": "Co je na tom zajímavé",
  "sketch.prominent": "Co z tebe nejvíc vystupuje",
  "sketch.leaning": "Kam se nejvíc přikláníš",
  "sketch.leans": "spíš {pole}",
  "sketch.balanced": "Kde je to vyrovnané",
  "sketch.balancedNote": "Tady se přikláníš podle situace a podle lidí kolem.",
  "sketch.notComputed": "{name}: na odhad je málo odpovědí.",
  "sketch.hint": "≈ náznak",
  "sketch.legend.band": "pásmo, kde nejspíš jsi",
  "sketch.legend.low": "čárkovaně: škála měří méně přesně, ber ji jako náznak",
  "sketch.legend.order": "Střed pruhu je tvůj vlastní průměr, pořadí je jen uvnitř tebe, bez srovnání s ostatními.",
  "sketch.top.strengths": "Tvoje nejsilnější podrobně",
  "sketch.top.work": "Kde se nejvíc najdeš",
  "sketch.order.bottom": "Co je u tebe spíš v pozadí",
  "sketch.order.all": "Celé pořadí",
  "sketch.order.place": "{place}.",
  "sketch.dominant": "Ctnost, která u tebe vede",
  "sketch.dominantNote": "Ctnost je skupina silných stránek, ne samostatně měřený rys.",
  "sketch.order.low": "méně výrazné u tebe",
  "sketch.order.high": "výraznější u tebe",
  "sketch.order.label": "{scale}: od pólu méně výrazné u tebe k pólu výraznější u tebe",
  "sketch.stars.label": "Hvězdy nejsilnějších silných stránek: {list}",
  "sketch.steps.label": "Cesta k nejsilnějším oblastem: {list}",
  "sketch.portrait.title": "Jak funguješ ty?",
  "sketch.portrait.captionLabelVisitor": "Jak to o sobě říká majitel obrazu",
  "sketch.portrait.captionBalanced": "Většinou mám obě strany, záleží na situaci.",
  "sketch.portrait.none": "Na obraz je zatím málo odpovědí.",
  "sketch.portrait.drawing": "Portrét se kreslí…",
  "sketch.portrait.send": "Poslat odkaz",
  "sketch.portrait.sent": "Odkaz je zkopírovaný",
  "sketch.portrait.inPicture": "V obraze: {element}",
  "sketch.portrait.picture.aura.neg": "tenký pruh zlatého světla kolem hlavy",
  "sketch.portrait.picture.aura.pos": "velká zlatá záře kolem hlavy",
  "sketch.portrait.picture.core_open.neg": "hluboká noční obloha a zářící poupě v hrudi",
  "sketch.portrait.picture.core_open.pos": "rudý západ slunce a rozvitý květ v hrudi",
  "sketch.portrait.picture.density.neg": "klidná obloha s dlouhými tahy",
  "sketch.portrait.picture.density.pos": "obloha plná vírů",
  "sketch.portrait.picture.head_mode.neg": "klidné tahy po obrysu hlavy",
  "sketch.portrait.picture.head_mode.pos": "vír v hlavě",
  "sketch.portrait.picture.palette_head.neg": "modrá hlava",
  "sketch.portrait.picture.palette_head.pos": "růžová hlava",
  "sketch.portrait.picture.sparks.neg": "nebe bez jisker",
  "sketch.portrait.picture.sparks.pos": "nebe plné jisker",
  "sketch.portrait.picture.reach.neg": "úzká ramena bez listů",
  "sketch.portrait.picture.reach.pos": "široká ramena a velké listy",
  "sketch.portrait.picture.reach_warmth.neg": "tyrkysová postava",
  "sketch.portrait.picture.reach_warmth.pos": "terakotová postava",
  "sketch.picture.drawing": "Obraz se kreslí…",
  "sketch.picture.failed": "Obraz se teď nepodařilo načíst.",
  "sketch.picture.download": "Stáhnout obrázek",
  "sketch.picture.share": "Sdílet obrázek",
  "sketch.picture.note": "Stáhneš celý svůj obraz. Odkaz pro sdílení ukáže jen vrstvu tohoto testu a náhled odkazu ukáže obraz.",
  "sketch.portrait.glance": "Na jeden pohled",
  "sketch.portrait.glance.prominent": "{count, plural, =1 {Jedna věc tě odlišuje od většiny lidí.} =2 {Dvě věci tě odlišují od většiny lidí.} =3 {Tři věci tě odlišují od většiny lidí.} =4 {Čtyři věci tě odlišují od většiny lidí.} =5 {Pět věcí tě odlišuje od většiny lidí.} =6 {Šest věcí tě odlišuje od většiny lidí.} =7 {Sedm věcí tě odlišuje od většiny lidí.} few {# věci tě odlišují od většiny lidí.} other {# věcí tě odlišuje od většiny lidí.}}",
  "sketch.portrait.glance.balanced": "{count, plural, =1 {V jedné další máš obě strany a záleží spíš na situaci.} =2 {Ve dvou dalších máš obě strany a záleží spíš na situaci.} =3 {Ve třech dalších máš obě strany a záleží spíš na situaci.} =4 {Ve čtyřech dalších máš obě strany a záleží spíš na situaci.} =5 {V pěti dalších máš obě strany a záleží spíš na situaci.} =6 {V šesti dalších máš obě strany a záleží spíš na situaci.} other {V # dalších máš obě strany a záleží spíš na situaci.}}",
  "sketch.portrait.differ": "Čím se lišíš",
  "sketch.portrait.differ.note": "Křivka ukazuje, kde je většina lidí. Tečka jsi ty, barevné pole je rozmezí, kde nejspíš jsi.",
  "sketch.portrait.signs": "Jak se to může projevovat",
  "sketch.portrait.question": "Na zamyšlení",
  "sketch.portrait.both": "Kde máš obě strany",
  "sketch.portrait.both.note": "Tady se nepřikláníš k jedné straně. Záleží spíš na situaci a na lidech kolem. I to něco říká: umíš obojí.",
  "sketch.portrait.middle": "Jsi uprostřed, tam, kde je většina lidí.",
  "sketch.portrait.share.approx": "asi {n}",
  "sketch.portrait.share.exact": "{n}",
  "sketch.portrait.bell.most": "většina lidí",
  "sketch.portrait.bell.left": "Tvoje tečka je vlevo od většiny lidí, na straně {pole}.",
  "sketch.portrait.bell.right": "Tvoje tečka je vpravo od většiny lidí, na straně {pole}.",
  "sketch.portrait.bell.middle": "Tvoje tečka je uprostřed, tam, kde je většina lidí.",
  "sketch.portrait.flower.label": "Květ s lístkem pro každou škálu. Delší lístek je dál od středu. Výrazné: {list}.",
  "sketch.portrait.flower.labelCalm": "Květ s lístkem pro každou škálu. Všechny lístky jsou blízko středu.",
  "sketch.portrait.flower.legend.mid": "střed škály",
  "sketch.portrait.flower.legend.prominent": "výrazné",
  "sketch.portrait.flower.legend.low": "měří méně přesně",
  "sketch.portrait.finish.title": "Dokresli si portrét",
  "sketch.portrait.finish.lead": "Skica ti ukázala, kde jsi. Portrét ti vysvětlí, co to pro tebe znamená a co s tím můžeš dělat.",
  "sketch.portrait.finish.what": "Co v Portrétu dostaneš",
  "sketch.portrait.finish.item.depth": "Podrobný výklad každé škály: co tvůj výsledek znamená a jak se projevuje v běžných situacích.",
  "sketch.portrait.finish.item.links": "Jak se tvoje vlastnosti navzájem potkávají a co z nich plyne dohromady.",
  "sketch.portrait.finish.item.watch": "Kde tě to může brzdit a na co si dát pozor.",
  "sketch.portrait.finish.item.plan": "Rozvojový plán: tři konkrétní kroky na příští měsíc.",
  "sketch.portrait.finish.item.pdf": "Celý výklad v PDF, ke kterému se můžeš vracet.",
  "portrait.page.label": "Portrét",
  "portrait.page.title": "Portrét · {test}",
  "portrait.page.lead": "Tady je tvůj osobní portrét: celistvý pohled na tebe, co tvůj výsledek znamená, jak se to projevuje v životě, jak se tvoje vlastnosti potkávají, kde tě to může brzdit a co s tím můžeš dělat.",
  "portrait.page.whole": "Tvůj celistvý portrét",
  "portrait.page.depth": "Co tvůj výsledek znamená",
  "portrait.page.scenes": "Jak se to u tebe projevuje",
  "portrait.page.scene_work": "V práci a rozhodování",
  "portrait.page.scene_relations": "Ve vztazích",
  "portrait.page.scene_stress": "V zátěži",
  "portrait.page.connections": "Jak se tvoje vlastnosti potkávají",
  "portrait.page.weak": "Kde tě to může brzdit",
  "portrait.page.practice": "Do praxe",
  "portrait.page.practice_do": "Co ti pomáhá",
  "portrait.page.practice_avoid": "Čeho se vyvarovat",
  "portrait.page.plan": "Tvůj plán na příští měsíc",
  "portrait.page.picture": "Tvůj obraz",
  "portrait.page.aiNote": "Napsáno pro tebe z tvého výsledku.",
  "portrait.page.otherLanguage": "Portrét je v jazyce, ve kterém proběhl test.",
  "portrait.page.drawing": "Portrét se dokresluje…",
  "portrait.page.drawingHint": "Obvykle to trvá do minuty. Stránka se sama obnoví, nemusíš nic dělat.",
  "portrait.page.later": "Dokončujeme ho, vrať se sem za chvíli. Najdeš ho i v Moje já.",
  "portrait.page.failed": "Portrét se teď nepodařilo dokončit. Už o tom víme, zkus se sem vrátit později.",
  "portrait.page.back": "Zpět na Skicu",
  "sketch.portrait.finish.open": "Dokreslit portrét",
  "sketch.portrait.finish.show": "Otevřít Portrét",
  "sketch.portrait.finish.devNote": "Na vývoji zdarma, platba přijde později.",
  "sketch.portrait.finish.unavailable": "Portrét teď nejde dokreslit, zkus to prosím později.",
  "me.portrait": "Portrét",
  "sketch.portrait.style.watercolor": "akvarel",
  "sketch.portrait.style.cubism": "kubismus",
  "sketch.portrait.style.impasto": "impasto",
  "sketch.portrait.style.ornament": "ornament",
  "sketch.portrait.style.geometry": "geometrie",
  "sketch.portrait.style.riso": "risograf",
  "sketch.portrait.preview.alt": "Tvůj portrét technikou {style}, malá ukázka",
  "sketch.portrait.preview.note": "Malé ukázky tvého portrétu. Celý obraz dostaneš po dokreslení.",
  "sketch.portrait.layer.title": "Tvůj portrét",
  "sketch.portrait.layer.count": "{done} {total, plural, one {z # vrstvy} few {ze # vrstev} =6 {ze # vrstev} =7 {ze # vrstev} other {z # vrstev}}",
  "sketch.portrait.layer.old": "Tohle je starší výsledek. Vrstva tohoto testu je v obraze z něj, ostatní z tvých nejnovějších testů.",
  "sketch.portrait.layer.new.base": "Nově: tvar za tvou hlavou.",
  "sketch.portrait.layer.new.inner": "Nově: barva nebe, záře a květ v hrudi.",
  "sketch.portrait.layer.new.sky": "Nově: hvězdy a polární záře nad hlavou.",
  "sketch.portrait.layer.new.land": "Nově: barevná pole a cesta z kamenů.",
  "sketch.portrait.layer.region": "Obraz",
  "sketch.portrait.example.alt": "Ukázka obrazu {n}: tvar za hlavou, barevná pole s cestou, hvězdy nad hlavou a postava s květem v hrudi.",
  "sketch.portrait.layer.inner": "V obraze: {list}.",
  "sketch.portrait.layer.sky": "Hvězdy nad hlavou: tvoje nejsilnější stránky. Největší hvězda: {name}.",
  "sketch.portrait.layer.land": "Barevná pole a kameny na cestě: oblasti práce, které tě baví. Zlatý kámen: {name}.",
  "sketch.portrait.layer.base.backdrop_shape.neg": "Oblouk za tvou hlavou: tvoje věrnost osvědčenému.",
  "sketch.portrait.layer.base.backdrop_shape.pos": "Volné laloky a kontrastní barva za tvou hlavou: tvoje otevřenost novému.",
  "sketch.portrait.layer.base.backdrop_layers.neg": "Jeden klidný prstenec za tvou hlavou: tvoje potřeba klidu a vlastního prostoru.",
  "sketch.portrait.layer.base.backdrop_layers.pos": "Několik prstenců za tvou hlavou: tvoje energie mezi lidmi.",
  "sketch.portrait.layer.base.backdrop_warmth.neg": "Levandulová barva za tvou hlavou: umíš říct věci na rovinu a stát si za svým.",
  "sketch.portrait.layer.base.backdrop_warmth.pos": "Terakotová barva za tvou hlavou: tvoje trpělivost a vstřícnost k druhým.",
  "sketch.portrait.layer.base.backdrop_cut.neg": "Neklidné tahy v tvaru za hlavou: tvoje volnost a plánování za pochodu.",
  "sketch.portrait.layer.base.backdrop_cut.pos": "Pravidelné tahy po obrysu tvaru: tvoje pečlivost a smysl pro řád.",
  "sketch.portrait.layer.base.backdrop_softness.neg": "Ostrá hrana tvaru: tvoje vyrovnanost, i když je napětí.",
  "sketch.portrait.layer.base.backdrop_softness.pos": "Okraj, který se rozpíjí do nebe: tvoje citlivost a potřeba blízkosti.",
  "sketch.portrait.layer.base.backdrop_ornament.neg": "Tečky po okraji tvaru: tvoje chuť vyniknout a radost z krásných věcí.",
  "sketch.portrait.layer.base.backdrop_ornament.pos": "Prostý tvar bez teček: tvoje skromnost a férovost.",
  "sketch.share.layer": "Ostatní uvidí jen vrstvu tohoto testu, ne celý tvůj obraz. Náhled odkazu ukáže tento obraz.",
  "sketch.visitor.time": "Svůj si uděláš zdarma, zabere to {duration}.",
  "round.leading": "Zatím vedou",
  "round.leadingTie": "Zatím se o místo dělí:",
  "round.image.note": "Zatím tužkou. Barvu dostane na Skice po posledním kole.",
  "round.image.portrait": "Portrét tužkou podle dosavadních odpovědí.",
  "round.leadingNote": "Pořadí se ještě může změnit.",
  "sketch.noLink": "Odkaz na Skicu se v tomto zařízení nezachoval.",

  "og.result.description": "Skica z testu „{name}“ na mesketch.",
  "paywall.sketch": "Skica",
  "paywall.sketchDesc": "typ a dimenze",
  "paywall.have": "máš",
  "paywall.portrait": "Portrét",
  "paywall.portraitDesc": "všechny rysy, výklad a plán",
  "paywall.price": "190 Kč",
  "paywall.button": "Dokreslit portrét · 190 Kč (připravujeme)",
  "pairs.card.title": "Jak se potkáte?",
  "pairs.card.lead": "Pozvi partnera, kamaráda nebo kolegu. Vaše dva portréty dáme vedle sebe a ukážeme, kde si sednete a kde to bude drhnout.",
  "pairs.card.invite": "Pozvat do páru",
  "pairs.form.inviter": "Jak ti říká?",
  "pairs.form.inviterHint": "Pod tímhle jménem tě uvidí.",
  "pairs.form.invitee": "Koho zveš?",
  "pairs.form.inviteeHint": "Stačí přezdívka, celé jméno není potřeba.",
  "pairs.form.email": "Jeho e-mail (nepovinné)",
  "pairs.form.emailHint": "Pošleme pozvánku za tebe. Adresu si neukládáme.",
  "pairs.form.submit": "Vytvořit pozvánku",
  "pairs.form.back": "Zpět",
  "pairs.form.invalidLabel": "Přezdívka může mít nejvýš 40 znaků, bez e-mailu a odkazu.",
  "pairs.form.failed": "Pozvánku se nepodařilo vytvořit. Zkus to prosím znovu.",
  "pairs.created.title": "Pozvánka je hotová",
  "pairs.created.lead": "Odkaz pošli, komu patří: {name}. Platí do {date}.",
  "pairs.created.once": "Odkaz uvidíš jen teď. Když ho ztratíš, pozvánku zruš a založ novou.",
  "pairs.created.emailSent": "Pozvánku jsme poslali i e-mailem.",
  "pairs.created.copy": "Zkopírovat odkaz",
  "pairs.created.copied": "Zkopírováno",
  "pairs.created.share": "Sdílet odkaz",
  "pairs.created.done": "Hotovo",
  "pairs.list.title": "Tvoje páry",
  "pairs.state.waiting": "čeká na přijetí",
  "pairs.state.declined": "odmítnuto",
  "pairs.state.cancelled": "pozvánka zrušená",
  "pairs.state.expired": "pozvánka vypršela",
  "pairs.state.ready": "propojeno",
  "pairs.state.incomparable": "propojeno, výsledky nejde porovnat",
  "pairs.state.same_person": "propojeno, oba výsledky patří stejnému e-mailu",
  "pairs.state.unavailable": "propojeno, párový výsledek teď nejde připravit",
  "pairs.state.revoked": "propojení zrušeno",
  "pairs.open": "Otevřít pár",
  "pairs.cancelInvite": "Zrušit pozvánku",
  "pairs.revoke": "Zrušit propojení",
  "pairs.confirmNo": "Nechat",
  "pairs.invite.title": "{name} tě zve do páru",
  "pairs.invite.test": "Test: {test}",
  "pairs.invite.lead": "Uděláš test a uvidíš svůj výsledek. Pak se rozhodneš, jestli ho spojíš s výsledkem, který má {name}. Spojené výsledky uvidíte oba, souhlas jde kdykoli odvolat.",
  "pairs.invite.start": "Udělat test",
  "pairs.invite.useMine": "Spojit můj výsledek",
  "pairs.invite.loginForResult": "Máš výsledek jinde? Přihlas se",
  "pairs.invite.decline": "Odmítnout",
  "pairs.invite.declined": "Pozvánka je odmítnutá. Nic dalšího se nestane.",
  "pairs.invite.privacy": "Přezdívku, pod kterou tu jsi, nám dal ten, kdo tě zve. Pozvánku i přezdívku smažeme 30 dní po vypršení nebo odmítnutí.",
  "pairs.invite.privacyLink": "Ochrana osobních údajů",
  "pairs.invite.gone.title": "Pozvánka už neplatí",
  "pairs.invite.gone.lead": "Odkaz vypršel, už se použil, nebo ho ten, kdo zval, zrušil. Požádej o novou pozvánku.",
  "pairs.invite.self": "Tohle je tvoje pozvánka. Pošli odkaz tomu, koho zveš.",
  "pairs.invite.mismatch": "Tenhle výsledek do páru použít nejde. Udělej test znovu.",
  "pairs.join.title": "Spojit výsledky: ty a {name}",
  "pairs.join.yes": "Spojit",
  "pairs.join.decline": "Odmítnout",
  "pairs.join.later": "Teď ne",
  "pairs.join.login": "Přihlas se, ať můžeš propojení zrušit i z jiného zařízení.",
  "consent.pair_link.v1.invite": "Do páru půjde tvůj nejnovější výsledek tohoto testu. Až pozvaný přijme, uvidíte navzájem své umístění na všech škálách testu a své portréty a oba uvidíte párový výsledek. Souhlas můžeš kdykoli odvolat, pár se pak skryje oběma.",
  "consent.pair_link.v1.accept": "Do páru půjde tvůj nejnovější výsledek tohoto testu. Uvidíte navzájem své umístění na všech škálách testu a své portréty a oba uvidíte párový výsledek. Souhlas můžeš kdykoli odvolat, pár se pak skryje oběma.",
  "consent.pair_link.v1.decline": "Odmítnout pozvánku? Ten, kdo zval, uvidí, že je odmítnutá. Nic dalšího se nestane.",
  "consent.pair_link.v1.revoke": "Zrušit propojení? Párový výsledek se oběma skryje a smaže. Nejde to vrátit, nové propojení je nová pozvánka.",
  "consent.pair_link.v1.cancel": "Zrušit pozvánku? Odkaz přestane platit.",
  "pairs.page.title": "Ty a {name}",
  "pairs.page.you": "Ty",
  "pairs.page.portraits": "Vaše portréty",
  "pairs.page.harmony": "Kde si sednete",
  "pairs.page.complement": "Kde se doplňujete",
  "pairs.page.friction": "Kde to bude drhnout",
  "pairs.page.shared_risk": "Na co si dát pozor spolu",
  "pairs.page.tip": "Tip",
  "pairs.page.placeholder": "Ukázkové pravidlo",
  "pairs.page.none": "Pravidla u vás nenašla nic výrazného.",
  "pairs.page.scales": "Škála po škále",
  "pairs.page.meLeft": "Ty jsi víc vlevo, {name} víc vpravo.",
  "pairs.page.meRight": "Ty jsi víc vpravo, {name} víc vlevo.",
  "pairs.page.alike": "Jste na tom podobně.",
  "pairs.page.flower": "Květ vás obou",
  "pairs.page.flowerLabel": "Dva květy přes sebe: tvůj a druhý, {name}.",
  "pairs.page.groupNote": "Každého z vás porovnáváme s jeho srovnávací skupinou.",
  "pairs.page.incomparable": "Vaše výsledky jsou z verzí testu, které nejde porovnat.",
  "pairs.page.retake": "Udělej test znovu.",
  "pairs.page.retakeLogin": "Přihlas se před testem, ať ti nový výsledek patří i v páru.",
  "pairs.page.waitOther": "Čekáme, až {name} udělá test znovu.",
  "pairs.page.samePerson": "Oba výsledky teď patří stejnému e-mailu, párový výsledek proto nevznikne.",
  "pairs.page.unavailable": "Párový výsledek teď nejde připravit.",
  "me.pairs": "Páry",
  "me.pairs.none": "Zatím žádné páry. Pozvat můžeš z výsledku testu.",
  "mail.pair_invite.subject": "{name} tě zve do páru na mesketch",
  "mail.pair_invite.greeting": "Ahoj,",
  "mail.pair_invite.lead": "{name} tě zve, abyste si na mesketch dali vedle sebe svoje portréty a podívali se, kde si sednete a kde to bude drhnout. Pozvánku otevřeš tady:",
  "mail.pair_invite.button": "Otevřít pozvánku",
  "mail.pair_invite.validity": "Pozvánka platí {days} dní.",
  "mail.pair_invite.ignore": "Když o pozvánku nestojíš, nic nedělej, sama vyprší.",
  "mail.pair_invite.privacy": "Tvou adresu nám dal ten, kdo tě zve, jen kvůli této pozvánce. U nás ji neukládáme, odeslání zajišťuje služba Ecomail jako náš zpracovatel.",
} as const;

export type MessageKey = keyof typeof cs;
